import React from 'react'
import * as jnb from "react-bootstrap";   
export default function PublicHeader() {
  return (
    <React.Fragment>

<jnb.Navbar bg="light" expand="lg" >
        <jnb.Container fluid>
          <jnb.Navbar.Brand href="#" style={{ color: 'green', fontWeight: 'bold' }}><img src="../img/BOC.png" width="250px" alt="fewsr" className='px-4' /></jnb.Navbar.Brand>
          <jnb.Navbar.Toggle aria-controls="navbarScroll" />
          <jnb.Navbar.Collapse id="navbarScroll">
            {/* <jnb.Nav className="me-auto my-2 my-lg-0"style={{ maxHeight: '100px' }}navbarScroll>
          <jnb.Nav.Link href="/">Home</jnb.Nav.Link>
              <jnb.Nav.Link href="/">GOs</jnb.Nav.Link>
              <jnb.Nav.Link href="/">Circulars</jnb.Nav.Link>  
            </jnb.Nav>
            <jnb.Nav className='px-4'>
                <jnb.Nav.Link href="/login">SignIn</jnb.Nav.Link>
            </jnb.Nav> */}
          </jnb.Navbar.Collapse>
        </jnb.Container>
      </jnb.Navbar>
      </React.Fragment>
  )
}
